// extracted by mini-css-extract-plugin
export default {"field":"Tariff_field__Z5TIR"};